import React from 'react'

import { VerticalTimeline, VerticalTimelineElement } from 'react-vertical-timeline-component';
import 'react-vertical-timeline-component/style.min.css';


import { FaBriefcase, FaUniversity } from 'react-icons/fa'
import PageHeaderComponent from '../../components/pageHeader'
import './styles.scss'

const jobIds = ['isro', 'abi', 'spanidea', 'cdc', 'snu', 'brbps'];

const dateStartList = {
  'isro': 'January 2023',
  'abi': 'July 2022',
  'spanidea': 'May 2022',
  'cdc': 'May 2021',
  'snu': 'July 2019',
  'brbps': 'April 2016'
};

const dateEndList = {
  'isro': 'Present',
  'abi': 'January 2023',
  'spanidea': 'July 2022',
  'cdc': 'August 2021',
  'snu': 'May 2023 | Grade: 8.78/10.00',
  'brbps': 'April 2018 | Grade: 85%'

};

const positions = {
  'isro': 'Project Trainee (WebGIS)',
  'abi': 'Tech Intern',
  'spanidea': 'Software Development Intern',
  'cdc': 'Corporate Relations Intern',
  'snu': 'B.Tech. in Computer Science and Engineering',
  'brbps': 'Senior Secondary Education'
};
const companies = {
  'isro': 'Indian Space Research Organisation (ISRO)',
  'abi': 'AB InBev',
  'spanidea': 'SpanIdea Systems',
  'cdc': 'Career Development Center, Shiv Nadar University',
  'snu': 'Shiv Nadar University',
  'brbps': 'B.R. Birla Public School'
};

const companyURLs = {
  'isro': 'https://www.isro.gov.in/',
  'abi': 'https://www.ab-inbev.com/',
  'spanidea': 'https://spanidea.com/',
  'cdc': 'https://snu.edu.in/career-development',
  'snu': 'https://snu.edu.in/',
  'brbps': 'https://brbirlaschool.com/'
};

const details = {
  'isro': [
    'Web GIS project trainee at the Regional Remote Sensing Centre - West, National Remote Sensing Centre, ISRO.',
    'Working on Web GIS projects, using VMs for containerized development.',
    'Automating the Bhuvan Portal of ISRO for a document download functionality.',
    'Developing the map based National Health Resources Repository (NHRR) portal, includes heavy dataset running on Clickhouse with Flask APIs to serve the application.',
    'Deployed secure data sharing APIs using FastAPI with secret tokens and JWTs.',
    'Developed a highly secure and possibly unbreachable encryption algorithm.'
  ],
  'abi': [
    'Upskilled myself in the team UpscAle at AB InBev.',
    'Developed intranet webpages and reusable webparts on SharePoint Platform.',
    'Made a project to streamline the tasks previously performed with MS Excel. With a considerable revenue, this project had great impact on all the VPs of AB InBev.',
    'Made several Power Automate Flows to catalyze the tasks on SharePoint.',
    'Made a mini StackOverflow kind of application for the team using SharePoint, I call it QuickCode, to catalyse the development process for everyone. Even the graphics team was keen to use this project!'
  ],
  'spanidea': [
    'Joined as Summer Intern at Spanidea Systems.',
    'Made reusable widgets in Flutter.',
    'Developed dynamic and highly secure user module APIs with NodeJS and Postman that is still used by the organization in multiple projects.',
    'Developed website for a fashion recommendation system with Flask at backend.'
  ],
  'cdc': [
    'Corporate Relations intern with Career Development Center at Shiv Nadar University.',
    'Competition Analysis with different institutions.',
    'Cold Calling: Pitched to various organisations about the university.',
    'Organising Webinars: Connected with top notch leaders of industry and invited them for webinars at the university. Filling the industry-academia gap.',
    'Drafted Placement Policy V3.0'
  ],
  'snu': [
    'Pursuing my Bachelors of Technology in Computer Science and Engineering from Shiv Nadar University, Delhi NCR.',
    "Awarded the prestigious Dean's List thrice for exceptional academic performance.",
    "Exploring the multi-disciplinary curriculum by doing courses in management, leadership, mathematics and even history.",
    "Expected graduation in May 2023."
  ],
  'brbps': [
    'Completed my Senior Secondary from B.R. Birla Public School with Physics, Mathematics, Chemistry, English and Physical Education.',
    'Lead the school Badminton team.',
    'Got the gold medal in International Mathematics Olympiad (IMO).'
  ]
};


const workBackground = (jobId, education = false) => {
  return <VerticalTimelineElement 
    className="vertical-timeline-element--work"
    contentStyle={{ background: '#000000', color: '#fff' }}
    contentArrowStyle={{ borderRight: '7px solid  #000000' }}
    date={dateStartList[jobId] + ' - ' + dateEndList[jobId]}
    iconStyle={{ background: '#000000', color: '#fff' }}
    icon={education ? <FaUniversity /> : <FaBriefcase />}
  ><div className='timelineElement'>

      <h3 className="vertical-timeline-element-title">{positions[jobId]}</h3>
      <h4 className="vertical-timeline-element-subtitle"><a href={companyURLs[jobId]}>{companies[jobId]}</a></h4>
      <ol className='backgroundList'>
        {details[jobId].map((detail) => {
          return <li key={detail}>{detail}</li>
        })}

      </ol>
    </div>
  </VerticalTimelineElement>
}

const Background = () => {
  return (
    <section id="background" className='background'>
      <PageHeaderComponent
        headerText="Background"
      // icon={<BsInfoCircleFill size={40} />}
      />
      {/* <VerticalTimeline>
        <VerticalTimelineElement
          className="vertical-timeline-element--work"
          contentStyle={{ background: 'rgb(33, 150, 243)', color: '#fff' }}
          contentArrowStyle={{ borderRight: '7px solid  rgb(33, 150, 243)' }}
          date="2011 - present"
          iconStyle={{ background: 'rgb(33, 150, 243)', color: '#fff' }}
          icon={<faWork />}
        >
          <h3 className="vertical-timeline-element-title">Creative Director</h3>
          <h4 className="vertical-timeline-element-subtitle">Miami, FL</h4>
          <p>
            Creative Direction, User Experience, Visual Design, Project Management, Team Leading
          </p>
        </VerticalTimelineElement>
        <VerticalTimelineElement
          className="vertical-timeline-element--work"
          date="2010 - 2011"
          iconStyle={{ background: 'rgb(33, 150, 243)', color: '#fff' }}
          icon={<faWork />}
        >
          <h3 className="vertical-timeline-element-title">Art Director</h3>
          <h4 className="vertical-timeline-element-subtitle">San Francisco, CA</h4>
          <p>
            Creative Direction, User Experience, Visual Design, SEO, Online Marketing
          </p>
        </VerticalTimelineElement>
        <VerticalTimelineElement
          className="vertical-timeline-element--work"
          date="2008 - 2010"
          iconStyle={{ background: 'rgb(33, 150, 243)', color: '#fff' }}
          icon={<faWork />}
        >
          <h3 className="vertical-timeline-element-title">Web Designer</h3>
          <h4 className="vertical-timeline-element-subtitle">Los Angeles, CA</h4>
          <p>
            User Experience, Visual Design
          </p>
        </VerticalTimelineElement>
        <VerticalTimelineElement
          className="vertical-timeline-element--work"
          date="2006 - 2008"
          iconStyle={{ background: 'rgb(33, 150, 243)', color: '#fff' }}
          icon={<faWork />}
        >
          <h3 className="vertical-timeline-element-title">Web Designer</h3>
          <h4 className="vertical-timeline-element-subtitle">San Francisco, CA</h4>
          <p>
            User Experience, Visual Design
          </p>
        </VerticalTimelineElement>
        <VerticalTimelineElement
          className="vertical-timeline-element--education"
          date="April 2013"
          iconStyle={{ background: 'rgb(233, 30, 99)', color: '#fff' }}
          icon={<faUniversity />}
        >
          <h3 className="vertical-timeline-element-title">Content Marketing for Web, Mobile and Social Media</h3>
          <h4 className="vertical-timeline-element-subtitle">Online Course</h4>
          <p>
            Strategy, Social Media
          </p>
        </VerticalTimelineElement>
        <VerticalTimelineElement
          className="vertical-timeline-element--education"
          date="November 2012"
          iconStyle={{ background: 'rgb(233, 30, 99)', color: '#fff' }}
          icon={<faUniversity />}
        >
          <h3 className="vertical-timeline-element-title">Agile Development Scrum Master</h3>
          <h4 className="vertical-timeline-element-subtitle">Certification</h4>
          <p>
            Creative Direction, User Experience, Visual Design
          </p>
        </VerticalTimelineElement>
        <VerticalTimelineElement
          className="vertical-timeline-element--education"
          date="2002 - 2006"
          iconStyle={{ background: 'rgb(233, 30, 99)', color: '#fff' }}
          icon={<faUniversity />}
        >
          <h3 className="vertical-timeline-element-title">Bachelor of Science in Interactive Digital Media Visual Imaging</h3>
          <h4 className="vertical-timeline-element-subtitle">Bachelor Degree</h4>
          <p>
            Creative Direction, Visual Design
          </p>
        </VerticalTimelineElement>
        <VerticalTimelineElement
          iconStyle={{ background: 'rgb(16, 204, 82)', color: '#fff' }}
        // icon={<StarIcon />}
        />
      </VerticalTimeline> */}
      <VerticalTimeline>
        {
          jobIds.map((jobId) => {
            return jobId === 'snu'|| jobId ==='brbps' ? workBackground(jobId, true) :workBackground(jobId);
          }
          )
        }
      </VerticalTimeline></section>
  )
}

export default Background;